import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function TeAyudamosSection({ site = "www.kuelly.com.mx" }) {
  const KU_GREEN = "#2f5d35";

  return (
    <section className="position-relative bg-white py-5 overflow-hidden">
      <style>{`
        :root { --ku-green: ${KU_GREEN}; }

        /* --- Cinta superior izquierda --- */
        .ta-ribbon{
          position:absolute; top:16px; left:16px;
          background:var(--ku-green); color:#fff; font-weight:800;
          padding:8px 16px; letter-spacing:.08em; z-index:2;
          font-size: clamp(10px, 2vw, 12px);
          border-radius: 6px;
        }
        .ta-ribbon::after{
          content:""; position:absolute; left:0; bottom:-8px;
          width:16px; height:8px; background:var(--ku-green);
          clip-path: polygon(0 0, 100% 0, 0 100%);
          border-bottom-left-radius: 3px;
        }
        @media (max-width: 575.98px){
          .ta-ribbon{ top:12px; left:12px; padding:6px 12px; }
        }

        /* --- Título y subtítulo --- */
        .ta-title{
          font-size: clamp(28px, 6vw, 56px);
          font-weight: 900; letter-spacing:.02em; line-height:1.05; margin:0;
          color:#111;
        }
        .ta-colon{ color:#111; }
        .ta-sub{
          max-width: 980px; color:#222; margin-top:12px;
          font-size: clamp(14px, 2.4vw, 18px);
        }

        /* --- Línea con pines decorativos --- */
        .ta-line-wrap{ position:relative; margin:22px 0 26px; }
        .ta-line{ height:2px; background:rgba(0,0,0,.15); border-radius:1px; }
        .ta-pins{ position:absolute; inset:0; display:grid; grid-template-columns: repeat(4, 1fr); align-items:center; }
        .ta-pin{
          width:26px; height:26px; border-radius:50%;
          background:#fff; border:2px solid #111; display:flex;
          align-items:center; justify-content:center; font-weight:800;
          margin:auto; transform: translateY(-12px);
          font-size:14px;
        }
        @media (max-width: 575.98px){
          /* en móviles simplificamos */
          .ta-line-wrap{ margin:16px 0 18px; }
          .ta-pins{ display:none; }
        }

        /* --- Tarjetas/columnas --- */
        .ta-card{
          background:#fff; border:1px solid rgba(0,0,0,.06);
          border-radius:14px; padding:16px 16px;
          height:100%; display:flex; flex-direction:column;
          box-shadow: 0 6px 18px rgba(0,0,0,.04);
          transition: transform .15s ease, box-shadow .2s ease, border-color .2s ease;
        }
        .ta-card:hover{
          transform: translateY(-2px);
          box-shadow: 0 10px 22px rgba(0,0,0,.06);
          border-color: rgba(0,0,0,.08);
        }
        .ta-card h5{
          font-weight:800; margin-bottom:8px;
          font-size: clamp(16px, 2.6vw, 20px);
          color:#111;
        }
        .ta-card p{
          color:#1f1f1f; margin:0; font-size: clamp(13px, 2.3vw, 16px);
          line-height:1.6;
        }
        /* mejor respiración entre columnas en móviles */
        @media (max-width: 991.98px){
          .ta-card{ padding:14px; }
        }

        /* --- Franja inferior --- */
        .ta-band{
          background:var(--ku-green); color:#fff;
          position:relative; margin-top:36px;
          width:100%;
        }
        .ta-band-inner{
          padding:12px 16px; text-align:center; font-weight:700; letter-spacing:.03em;
          font-size: clamp(13px, 2.4vw, 16px);
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }

        /* --- utilidades --- */
        .ta-gx{
          --bs-gutter-x: 1.25rem;
        }
      `}</style>

      {/* Cinta */}
      <div className="ta-ribbon">KUELLY</div>

      <Container>
        {/* Título */}
        <Row className="mb-2">
          <Col>
            <h1 className="ta-title">
              TE AYUDAMOS<span className="ta-colon">:</span>
            </h1>
            <p className="ta-sub">
              En Kuelly, entendemos que cada cliente tiene necesidades únicas. Por ello, hemos
              desarrollado cuatro áreas de especialización para brindarte un servicio completo.
            </p>
          </Col>
        </Row>

        {/* Línea con pines */}
        <div className="ta-line-wrap">
          <div className="ta-line" />
          <div className="ta-pins">
            <div className="ta-pin">×</div>
            <div className="ta-pin">×</div>
            <div className="ta-pin">×</div>
            <div className="ta-pin">×</div>
          </div>
        </div>

        {/* 4 columnas responsivas */}
        <Row className="gy-4 ta-gx">
          <Col xs={12} md={6} lg={3}>
            <div className="ta-card">
              <h5>Arrendadora</h5>
              <p>
                Te ofrecemos una amplia cartera de propiedades de calidad, ubicadas estratégicamente en
                los mejores lugares para vivir o establecer tu negocio. Nuestro servicio va más allá de un
                simple alquiler: te garantizamos transparencia, contacto y mantenimiento constante de la
                propiedad, para que tu experiencia sea segura, cómoda y sin preocupaciones.
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <div className="ta-card">
              <h5>Comercializadora</h5>
              <p>
                Buscas comprar o vender, estamos aquí para ayudarte. Te ayudamos a encontrar el hogar o la
                inversión perfecta que se adapte a tus expectativas y presupuesto. Nuestro equipo de
                expertos utiliza herramientas de mercado para maximizar tu operación y asegurar el mejor
                resultado posible.
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <div className="ta-card">
              <h5>Constructora</h5>
              <p>
                Desarrollamos proyectos de construcción con los más altos estándares de calidad, seguridad
                y diseño. Desde la conceptualización hasta la entrega final, cuidamos materiales, técnicas
                y procesos para crear soluciones funcionales, estéticas y duraderas que superen tus
                expectativas.
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <div className="ta-card">
              <h5>Inmobiliaria</h5>
              <p>
                Ya sea que estés comprando, vendiendo o rentando, te acompañamos con asesoría legal,
                administrativa y comercial para que cada trámite sea sencillo y transparente. Nos
                enfocamos en tus objetivos y coordinamos cada paso para brindarte una experiencia
                eficiente, exitosa y libre de estrés.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Franja inferior con sitio */}
      <div className="ta-band">
        <div className="ta-band-inner">{site}</div>
      </div>
    </section>
  );
}
